import { render, staticRenderFns } from "./ProductList.vue?vue&type=template&id=60d92d87&"
import script from "./ProductList.vue?vue&type=script&lang=js&"
export * from "./ProductList.vue?vue&type=script&lang=js&"
import style0 from "./ProductList.vue?vue&type=style&index=0&id=60d92d87&prod&lang=css&"
import style1 from "./ProductList.vue?vue&type=style&index=1&id=60d92d87&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports